// extracted by mini-css-extract-plugin
module.exports = {"products":"bu-z","misad":"cu-z","oosMessaging":"du-z"};